module.exports = __webpack_public_path__ + "img/des_distanceday_3.bd8b368d.jpg";